export default __webpack_public_path__ + "static/media/md.e51ce85d.jpg";